import { render } from "./KoTatouDashboard.vue?vue&type=template&id=601bb118&scoped=true"
import script from "./KoTatouDashboard.vue?vue&type=script&lang=js"
export * from "./KoTatouDashboard.vue?vue&type=script&lang=js"

import "./KoTatouDashboard.vue?vue&type=style&index=0&id=601bb118&scoped=true&lang=css"
import "./KoTatouDashboard.vue?vue&type=style&index=1&id=601bb118&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601bb118"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QTable,QTd,QBtn,QDialog,QCard,QCardSection,QTooltip});qInstall(script, 'directives', {ClosePopup});
